import { useEffect, useState } from "react"

const TICK_INTERVAL_MS = 60_000

const subscribers = new Set<(now: number) => void>()
let intervalId: ReturnType<typeof setInterval> | null = null

const startInterval = () => {
  if (intervalId !== null) return
  intervalId = setInterval(() => {
    const now = Date.now()
    subscribers.forEach((fn) => fn(now))
  }, TICK_INTERVAL_MS)
}

const stopInterval = () => {
  if (intervalId === null) return
  clearInterval(intervalId)
  intervalId = null
}

export const useStalenessTick = (): number => {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    subscribers.add(setNow)
    startInterval()
    return () => {
      subscribers.delete(setNow)
      if (subscribers.size === 0) {
        stopInterval()
      }
    }
  }, [])

  return now
}
